<template>
  <el-container>
    <el-header class="rowMargin">
      <el-row class="flex justify-center">
        <h1>Reporte de Tareas Semanal</h1>
      </el-row>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="14">
          <el-row>
            <el-col :span="2"> Leyenda: </el-col>
            <el-col :offset="1" :span="3">
              <el-tag type="">Abierta a Tiempo | {{ OnTimeOpen }} |</el-tag>
            </el-col>
            <el-col :offset="2" :span="3">
              <el-tag type="success"
                >Cerrada a Tiempo | {{ OntimeCloced }} |</el-tag
              >
            </el-col>
            <el-col :offset="2" :span="3">
              <el-tag type="warning"
                >Abierta a Retrasada | {{ DelayedOpen }} |</el-tag
              >
            </el-col>
            <el-col :offset="2" :span="3">
              <el-tag type="danger"
                >Cerrada a Retrasada | {{ DelayedClosed }} |</el-tag
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2"> Fijadas: </el-col>
            <el-col :offset="1" :span="3">
              <el-tag type="" effect="dark"
                >Abierta a Tiempo | {{ FixedOnTimeOpen }} |</el-tag
              >
            </el-col>
            <el-col :offset="2" :span="3">
              <el-tag type="success" effect="dark"
                >Cerrada a Tiempo | {{ FixedOntimeCloced }} |</el-tag
              >
            </el-col>
            <el-col :offset="2" :span="3">
              <el-tag type="warning" effect="dark"
                >Abierta a Retrasada | {{ FixedDelayedOpen }} |</el-tag
              >
            </el-col>
            <el-col :offset="2" :span="3">
              <el-tag type="danger" effect="dark"
                >Cerrada a Retrasada | {{ FixedDelayedClosed }} |</el-tag
              >
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="10">
          <el-row class="justifiyingContent">
            <el-col :span="4" class="justifiyingContent AligningContent">
              <h1
                :class="{
                  green: ProductivityPercentage > 90,
                  orange:
                    ProductivityPercentage >= 80 && ProductivityPercentage < 90,
                  red: ProductivityPercentage <= 80,
                  ResponsibleName: true
                }"
              >
                {{ ProductivityPercentage }} %
              </h1>
            </el-col>
            <el-col :span="8" class="AligningContent">
              <el-row>
                <el-col :span="24" class="justifiyingContent marginBottom">
                  <el-avatar
                    shape="circle"
                    :size="100"
                    fit="fill"
                    :src="SetResponsibleAvatar"
                  ></el-avatar>
                </el-col>

                <el-col :span="24" class="justifiyingContent">
                  <el-col :span="16" class="justifiyingContent">
                    <h6 class="ResponsibleName">{{ SetResponsibleName }}</h6>
                  </el-col>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="18">
                  <p class="MyParagraph">Horas Semanales</p>
                </el-col>
                <el-col :span="6" class="JustifyEnd">
                  <p class="MyParagraph">{{ WeekHours }}</p>
                </el-col>
                <hr />
                <el-col :span="18">
                  <p class="MyParagraph">Horas Asignadas</p>
                </el-col>
                <el-col :span="6" class="JustifyEnd">
                  <p
                    :class="{ MyParagraph: true, red: WeekAssignedHours < 40 }"
                  >
                    {{ WeekAssignedHours }}
                  </p>
                </el-col>
                <hr />
                <el-col :span="18">
                  <p class="MyParagraph">Horas Productivas</p>
                </el-col>
                <el-col :span="6" class="JustifyEnd">
                  <p class="MyParagraph">{{ ClosedHours }}</p>
                </el-col>
                <hr />
                <el-col :span="18">
                  <p class="MyParagraph">Productividad</p>
                </el-col>
                <el-col :span="6" class="JustifyEnd">
                  <p
                    :class="{
                      MyParagraph: true,
                      green: ProductivityPercentage > 90,
                      orange:
                        ProductivityPercentage >= 80 &&
                        ProductivityPercentage < 90,
                      red: ProductivityPercentage <= 80,
                      ResponsibleName: true
                    }"
                  >
                    {{ ProductivityPercentage }} %
                  </p>
                </el-col>
                <hr />
                <el-col :span="18">
                  <p class="MyParagraph">Horas No productivas</p>
                </el-col>
                <el-col :span="6" class="JustifyEnd">
                  <p
                    :class="{ MyParagraph: true, red: NoProductivityHours > 4 }"
                  >
                    {{ NoProductivityHours }}
                  </p>
                </el-col>
                <hr />
                <el-col :span="18">
                  <p class="MyParagraph">Salario x Horas</p>
                </el-col>
                <el-col :span="6" class="JustifyEnd">
                  <p class="MyParagraph">{{ HoursSalary }}</p>
                </el-col>
                <hr />
                <el-col :span="18">
                  <p class="MyParagraph">Salario Semana No Productivo</p>
                </el-col>
                <el-col :span="6" class="JustifyEnd">
                  <p class="MyParagraph red">{{ NoProductivitySalary }}</p>
                </el-col>
                <hr />
                <el-col :span="18">
                  <p class="MyParagraph">Proyeccion Salario No Productivo</p>
                </el-col>
                <el-col :span="6" class="JustifyEnd">
                  <p class="MyParagraph red">
                    {{ NoProductivitySalaryProjection }}
                  </p>
                </el-col>
                <hr />
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="3">
          <YearsComponent @change="onYearChange" :disabled="loadingData" />
        </el-col>
        <el-col class="colMargin" :span="3">
          <MonthsComponent
            :initial="actualMonth"
            @change="onMonthChange"
            :isDisabled="loadingData"
          />
        </el-col>
        <el-col class="colMargin" :span="3">
          <DirectionSelector
            :initialDirection="filters.Direction"
            @selection-change="OnDirectionSelected"
            :isDisabled="loadingData"
          />
        </el-col>
        <el-col class="colMargin" :span="3">
          <DepartmentsComponent
            :initialDirection="filters.Direction"
            :initialDeparment="filters.Deparment"
            :DirecctionID="filters.Direction"
            fieldSize="mini"
            @selectionChange="OnDeparmentSelected"
            :isDisabled="loadingData"
          />
        </el-col>
        <el-col class="colMargin" :span="3">
          <EmployeeSelector
            :DireccionParams="filters.Direction"
            :DeparmentParams="filters.Deparment"
            :CurrentEmployee="filters.Responsible"
            placeholder="Responsable"
            @selection-change="OnResponsibleSelected"
            :disabled="loadingData"
          />
        </el-col>
        <el-col class="colMargin" :span="3">
          <StatusSelector @StatusSelected="OnStatusSelected" />
        </el-col>
        <el-col :span="4" class="flex justify-flex-end">
          <el-button
            type="primary"
            icon="el-icon-time"
            size="mini"
            @click="openingTimeAsigment"
            :loading="loadingData"
            :disabled="loadingData"
            >Asignar Tiempos</el-button
          >
        </el-col>
        <el-col :span="1" class="flex justify-flex-end">
          <el-tooltip
            class="item"
            effect="light"
            content="Reordena Tareas"
            placement="top"
          >
            <el-button
              type="primary"
              icon="el-icon-refresh"
              size="mini"
              circle
              :loading="loadingData"
              :disabled="loadingData"
              @click="ReorderTasksMethod"
            ></el-button>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row>
        <el-tabs
          :class="{ green: true }"
          v-model="TabName"
          type="border-card"
          @tab-click="handleTabClick"
        >
          <el-tab-pane
            v-for="week in NumberofWeeksInMonth"
            :key="week"
            :name="week"
            :label="`Semana ${week}`"
            :disabled="loadingData"
          >
            <template #label>
              <span
                :class="{
                  'custom-tab':
                    week === ActualWeekNumber &&
                    actualMonth === filters.Month &&
                    actualYear === filters.Year
                }"
              >
                Semana {{ week }}
              </span>
            </template>
          </el-tab-pane>
          <el-tab-pane
            :key="10"
            :name="10"
            label="Tareas Retrasadas"
            :disabled="loadingData"
          >
          </el-tab-pane>
          <!-- <el-tab-pane
            :name="2"
            label="Semana 2"
            :disabled="loadingData"
          ></el-tab-pane>
          <el-tab-pane
            :name="3"
            label="Semana 3"
            :disabled="loadingData"
          ></el-tab-pane>
          <el-tab-pane
            :name="4"
            label="Semana 4"
            :disabled="loadingData"
          ></el-tab-pane>
          <el-tab-pane
            :name="5"
            label="Semana 5"
            :disabled="loadingData"
          ></el-tab-pane> -->
        </el-tabs>
        <rabbey-table-3
          v-if="
            this.filters.Responsible === this.currentUser.EmployeeId ||
            AmIsupervisor
          "
          :border="true"
          :stripe="true"
          :actions="TaskActions"
          @rtable-push-action="handlePushAction"
          :loading="loadingData"
          :data="FilteredTasks"
          :columns="TaskColumns"
          show-summary
          sum-text="Tiempo Total"
          :summary-method="getSummaries"
          page_Size="500"
          :pageSizes="[500, 1000]"
        />
      </el-row>
      <TimeAssigment
        :isItVisible="isTimeAssigmentVisible"
        :actualResquest="actualResquest"
        :whatsFor="whatsFor"
        :filtersForData="filtersForData"
        :ActualWeekNumber="ActualWeekNumber"
        @TaskAdded="UpdateTimeAsigmentData"
        @DialogCloses="OntimeAssigmentCloses"
        @EmployeedSelected="OnEmployeedSelected"
      />
      <EvidenceDialog
        :isItVisible="isEvidenceDialogVisible"
        :RequestTaskId="RequestTaskId"
        :RTID="RequestTaskOriginalId"
        @updateReport="onUpdateReport"
        @DialogCloses="onEvidenceClose"
      />
      <CloseServiceRequestDialog
        :isItVisible="isCloseServiceRequestDialogVisible"
        :RequestTaskId="RequestTaskId"
        :RTID="RequestTaskOriginalId"
        @UpdateTaskReport="onUpdateReport"
        @ClosingServiceRequesCloseDialog="OnClosingServiceRequesCloseDialog"
      />
      <InternalRequestDrawer
        :drawer="isDetailsVisible"
        :data="DetailsDialogData"
        @InternalRequestDrawerClose="OnClosingDetailsDialog"
      />
      <EditResponsable
        :ResponsibleDialogVisible="isResponsibleDialogVisible"
        :ActualTaskInfo="ActualTaskInfo"
        @ResponsibleDialogClose="OnResponsibleDialogClose"
        @ResponsibleUpdated="OnResponsibleUpdated"
      />
      <ChangeTaskDueDate
        :DueDateDialogVisible="IsDueDateDialogVisible"
        :ActualTaskInfo="ActualTaskInfo"
        @ClosingDueDateDialog="OnClosingDueDateDialog"
        @NewDueDateUpdated="OnNewDueDateUpdated"
      />

      <ChangeCloseDate
        :CloseDateDialogVisible="IsCloseDateDialogVisible"
        :ActualTaskInfo="ActualTaskInfo"
        @ClosingCloseDateDialog="OnClosingCloseDateDialog"
        @NewCloseDateUpdated="OnNewCloseDateUpdated"
      />
    </el-main>
  </el-container>
</template>

<script>
import TasksReportColumns, {
  TaskReportActions
} from "@/columns/TasksReportColumns";
import YearsComponent from "@/components/Global_System/YearsComponent";
import MonthsComponent from "@/components/Global_System/MonthsComponent";
import DirectionSelector from "@/components/Company/DirectionSelector";
import DepartmentsComponent from "@/components/Company/DepartmentsComponent";
import EmployeeSelector from "@/components/Company/EmployeeSelector";
import TimeAssigment from "@/components/internal_requests/KPI/TasksReport/TimeAssigment";
import EvidenceDialog from "@/components/internal_requests/KPI/TasksReport/EvidenceDialog";
import CloseServiceRequestDialog from "@/components/internal_requests/KPI/TasksReport/CloseServiceRequestDialog";
import InternalRequestDrawer from "@/components/internal_requests/InternalRequestDrawer";
import EditResponsable from "@/components/internal_requests/KPI/TasksReport/EditResponsable";
import ChangeTaskDueDate from "@/components/internal_requests/KPI/TasksReport/ChangeTaskDueDate";
import { formatMonto } from "@/utils";
import StatusSelector from "@/components/internal_requests/KPI/TasksReport/StatusSelector";
import ChangeCloseDate from "@/components/internal_requests/KPI/TasksReport/ChangeCloseDate.vue";

const actualYear = new Date().getFullYear();
const actualMonth = new Date().getMonth() + 1;
export default {
  name: "TasksReport",
  components: {
    YearsComponent,
    MonthsComponent,
    DirectionSelector,
    DepartmentsComponent,
    EmployeeSelector,
    TimeAssigment,
    EvidenceDialog,
    CloseServiceRequestDialog,
    InternalRequestDrawer,
    EditResponsable,
    ChangeTaskDueDate,
    StatusSelector,
    ChangeCloseDate
  },
  data() {
    return {
      // Define your data properties here
      TabName: 1,
      TasksData: [],
      TaskColumns: TasksReportColumns,
      TaskActions: TaskReportActions(this),
      loadingData: false,
      AmIsupervisor: false,
      filters: {
        Year: actualYear,
        Month: actualMonth,
        Direction: 0,
        Deparment: 0,
        Responsible: 0,
        Status: 0
      },
      filtersForData: {},
      isTimeAssigmentVisible: false,
      isEvidenceDialogVisible: false,
      RequestTaskId: "",
      RequestTaskOriginalId: 0,
      actualResquest: [],
      whatsFor: "",
      isCloseServiceRequestDialogVisible: false,
      EmploySelected: 0,
      actualMonth: actualMonth,
      actualYear: actualYear,
      isDetailsVisible: false,
      DetailsDialogData: {
        requestsId: 0,
        comments: [],
        descripcionLaga: "",
        descripcionCorta: "",
        commentReasonToReopen: "",
        Reopen: "",
        evidences: []
      },
      isResponsibleDialogVisible: false,
      ActualTaskInfo: {},
      IsDueDateDialogVisible: false,
      IsCloseDateDialogVisible: false,
      ActualWeekNumber: 0,
      DelayedTasks: []
      //NumberofWeeksInMonth: 5,
    };
  },
  computed: {
    // Define your computed properties here
    OnTimeOpen() {
      return this.TasksData.filter(
        (td) =>
          td.DelayedDays <= 0 &&
          td.IsItClosed === false &&
          (td.IsFixed === null || td.IsFixed === false)
      ).length;
    },
    OntimeCloced() {
      return this.TasksData.filter(
        (td) =>
          td.DelayedDays <= 0 &&
          td.IsItClosed === true &&
          (td.IsFixed === null || td.IsFixed === false)
      ).length;
    },
    DelayedOpen() {
      return this.TasksData.filter(
        (td) =>
          td.DelayedDays > 0 &&
          td.IsItClosed === false &&
          (td.IsFixed === null || td.IsFixed === false)
      ).length;
    },
    DelayedClosed() {
      return this.TasksData.filter(
        (td) =>
          td.DelayedDays > 0 &&
          td.IsItClosed === true &&
          (td.IsFixed === null || td.IsFixed === false)
      ).length;
    },
    FixedOnTimeOpen() {
      return this.TasksData.filter(
        (td) =>
          td.DelayedDays <= 0 &&
          td.IsItClosed === false &&
          td.IsFixed !== null &&
          td.IsFixed === true
      ).length;
    },
    FixedOntimeCloced() {
      return this.TasksData.filter(
        (td) =>
          td.DelayedDays <= 0 &&
          td.IsItClosed === true &&
          td.IsFixed !== null &&
          td.IsFixed === true
      ).length;
    },
    FixedDelayedOpen() {
      return this.TasksData.filter(
        (td) =>
          td.DelayedDays > 0 &&
          td.IsItClosed === false &&
          td.IsFixed !== null &&
          td.IsFixed === true
      ).length;
    },
    FixedDelayedClosed() {
      return this.TasksData.filter(
        (td) =>
          td.DelayedDays > 0 &&
          td.IsItClosed === true &&
          td.IsFixed !== null &&
          td.IsFixed === true
      ).length;
    },
    NumberofWeeksInMonth() {
      return this.getWeeksInMonth(this.filters.Year, this.filters.Month);
    },
    SetResponsibleAvatar() {
      const responsibleAvatar = this.TasksData.map(
        (task) => task.ResponsiblePhoto
      )[0];
      return responsibleAvatar;
    },
    SetResponsibleName() {
      const responsibleName = this.TasksData.map(
        (task) => task.ResponsibleName
      )[0];
      return responsibleName;
    },
    ProductivityPercentage() {
      const productivity = Math.round(
        (this.TasksData.filter((t) => t.IsItClosed === true)
          .map((t) => t.TimeOntask)
          .reduce((a, b) => a + b, 0) /
          44) *
          100
      );
      return productivity;
    },
    ClosedHours() {
      const closedHours = this.TasksData.filter((t) => t.IsItClosed === true)
        .map((t) => t.TimeOntask)
        .reduce((a, b) => a + b, 0);
      return closedHours;
    },

    WeekHours() {
      const weekHours = 44;
      /*
      this.TasksData.filter((t) => t.IsItClosed === false)
        .map((t) => t.TimeOntask)
        .reduce((a, b) => a + b, 0);
        */
      return weekHours;
    },
    WeekAssignedHours() {
      const weekAssignedHours = this.TasksData.filter((t) => t.TimeOntask > 0)
        .map((t) => t.TimeOntask)
        .reduce((a, b) => a + b, 0);
      return weekAssignedHours;
    },
    NoProductivityHours() {
      const noProductivityHours = this.WeekHours - this.ClosedHours;
      /*
      this.TasksData.filter((t) => t.IsItClosed === false && t.TimeOntask === 0)
        .map((t) => t.TimeOntask)
        .reduce((a, b) => a + b, 0);
        */
      return noProductivityHours;
    },
    HoursSalary() {
      const salary = formatMonto(
        (this.TasksData[0]?.ResponsibleSalary ?? 0) / 23.83 / 8
      );
      return salary;
    },
    NoProductivitySalary() {
      const noProductivitySalary = formatMonto(
        this.NoProductivityHours * this.HoursSalary
      );
      return noProductivitySalary;
    },
    NoProductivitySalaryProjection() {
      const beforFormatting =
        parseFloat(this.NoProductivitySalary.replace(/,/g, "")) * 4;

      const noProductivitySalaryProjection = formatMonto(beforFormatting);

      return noProductivitySalaryProjection;
    },
    FilteredTasks() {
      let filteredTasks = [];
      if (this.filters.Status === 1) {
        filteredTasks = this.TasksData.filter(
          (task) => task.IsItClosed === false && task.TimeOntask > 0
        );
      } else if (this.filters.Status === 3) {
        filteredTasks = this.TasksData.filter(
          (task) =>
            (task.IsItClosed === false && task.TimeOntask === 0) ||
            task.TimeOntask === null
        );
      } else if (this.filters.Status === 2) {
        filteredTasks = this.TasksData.filter(
          (task) => task.IsItClosed === true
        );
      } else {
        filteredTasks = this.TasksData;
      }

      return filteredTasks;
    }
  },

  beforeMount() {
    // Example: Get week number of today with Monday as start of the week (1)
    this.ActualWeekNumber = this.getWeekOfMonth(new Date(), 0);
    this.TabName = this.getWeekOfMonth(new Date(), 0); // 1 for Monday, 0 for Sunday
    (this.filters.Direction = this.currentUser.DireccionID),
      (this.filters.Deparment = this.currentUser.DepartamentID),
      (this.filters.Responsible = this.currentUser.EmployeeId);
    // this.InitialDirection = this.currentUser.DireccionID

    //this.GetDataForReport();
  },
  async mounted() {
    const actualDate = new Date();

    this.actualMonth = actualDate.getMonth() + 1;
    (this.filters.Direction = this.currentUser.DireccionID),
      (this.filters.Deparment = this.currentUser.DepartamentID),
      (this.filters.Responsible = this.currentUser.EmployeeId);

    this.KnowIfIsHisSupervisor(this.filters.Responsible);
    await this.ReorderTasksMethod();
    await this.GetRequestTasksData();
  },
  methods: {
    // Define your methods here
    async GetRequestTasksData() {
      if (
        this.filters.Responsible === this.currentUser.EmployeeId ||
        this.AmIsupervisor
      ) {
        this.loadingData = true;
        this.TasksData = [];
        // Si el tab seleccionado es el 10, hacemos 6 peticiones (semana 1..6)
        // y acumulamos todos los resultados en `TasksData`.
        if (Number(this.TabName) === 10) {
          this.TasksData = [];
          try {
            const requests = [];
            const maxWeeks = Number(this.NumberofWeeksInMonth) || 5;
            for (let week = 1; week <= maxWeeks; week++) {
              requests.push(
                this.$http.get("/api/ReporteGestion/GetAllTaskForReport", {
                  params: {
                    CompanySelected: "TB",
                    GerenciaID: this.filters.Direction,
                    ResponsableID: this.filters.Responsible,
                    WeekOnMothSelected: week,
                    Year: this.filters.Year,
                    Month: this.filters.Month,
                    closed: false,
                    OnlyDelayed: true
                  }
                })
              );
            }

            const responses = await Promise.all(requests);
            responses.forEach((r) => {
              const data = r.data;
              if (Array.isArray(data)) {
                const filtered = data.filter(
                  (item) =>
                    Number(item.DelayedDays) >= 1 && item.IsItClosed === false
                );
                if (filtered.length) {
                  this.TasksData = this.TasksData.concat(filtered);
                }
              } else if (
                data &&
                Number(data.DelayedDays) >= 1 &&
                data.IsItClosed === false
              ) {
                this.TasksData.push(data);
              }
            });

            // Eliminar duplicados por `ID`, mantener la primera aparición
            const seen = new Set();
            const unique = [];
            this.TasksData.forEach((task) => {
              const id = task && task.ID;
              if (id == null) return;
              if (!seen.has(id)) {
                seen.add(id);
                unique.push(task);
              }
            });
            this.TasksData = unique;
            this.loadingData = false;
          } catch (err) {
            this.loadingData = false;
            this.$message.error("Error al cargar las tareas retrasadas.");
          }
        } else {
          try {
            const response = await this.$http.get(
              "/api/ReporteGestion/GetAllTaskForReport",
              {
                params: {
                  CompanySelected: "TB",
                  GerenciaID: this.filters.Direction,
                  ResponsableID: this.filters.Responsible,
                  WeekOnMothSelected: this.TabName,
                  Year: this.filters.Year,
                  Month: this.filters.Month,
                  closed: false
                }
              }
            );
            this.TasksData = response.data;
            this.loadingData = false;
          } catch (err) {
            this.loadingData = false;
            this.$message.error("Error al cargar los datos de las tareas.");
          }
        }
      }
    },
    async ReorderTasksMethod() {
      this.loadingData = true;
      this.TasksData = [];
      // await Promise.all(
      await this.$http
        .put("/api/ReporteGestion/ReorderTasksMethod", {
          CompanySelected: "TB",
          GerenciaID: this.filters.Direction,
          ResponsableID: this.filters.Responsible,
          WeekOnMothSelected: this.getWeekOfMonth(new Date(), 0),
          Year: this.filters.Year,
          Month: this.filters.Month,
          closed: false
        })
        .then((response) => {
          // this.TasksData = response.data;
          this.$message.success(`Se reordenaron ${response.data} registros.`);
          //this.loadingData = false;
          this.GetRequestTasksData();
        })
        .catch(() => {
          this.loadingData = false;
          this.$message.error("Error al cargar los datos de las tareas.");
        });
      // .finally(() => {
      //   this.loadingData = false;
      // });
      // );
    },
    RecalculateTaskData() {
      this.loadingData = true;
      this.$http
        .post("/api/ReporteGestion/Recalcular", {
          Responsable: this.filters.Responsible,
          Year: this.filters.Year
        })
        .then(() => {
          this.loadingData = false;
        })
        .catch(() => {
          this.loadingData = false;
          this.$message.error("Error al recalcular los datos de las tareas.");
        });
    },
    async ReopenTask(row) {
      const TaskID = parseInt(String(row.ID || "").replace(/\D/g, ""), 10);

      if (Number.isNaN(TaskID)) {
        this.$message({
          message: "No se pudo obtener un ID de tarea válido.",
          type: "error"
        });
        return;
      }

      await this.$prompt(
        "Por favor escribir un comentario para reabrir la tarea",
        "Mensaje de confirmación"
      )
        .then((result) => {
          if (result.action === "confirm") {
            if (result.value) {
              this.$http
                .post(
                  `/api/MessageApi/UpdateStateTaskGant?ID=${TaskID}&Comentarios=${result.value}`
                )
                .then(async () => {
                  this.$message({
                    message: "Tarea Reabierta Exitosamente",
                    type: "success"
                  });
                  await this.GetRequestTasksData();
                })
                .catch((err) => {
                  this.$message({ type: "danger", message: err });
                });
            } else {
              this.$message({
                message: "Favor introduzca un comentario válido",
                type: "error"
              });
            }
          }
        })
        .catch(() => {
          // Usuario canceló el prompt
        });
    },
    // GetDataForReport() {
    //   this.$http
    //     .get("api/ReporteGestion/ReporteGerencial", {
    //       params: {
    //         CompanySelected: "TB",
    //         GerenciaID: this.filters.Direction,
    //         ResponsableID: this.filters.Responsible,
    //         WeekNumber: this.TabName,
    //         Year: this.filters.Year,
    //         Month: this.filters.Month
    //       }
    //     })
    //     .then((response) => {
    //       this.TasksData = response.data;
    //     });
    // },
    async onYearChange(year) {
      this.actualMonth = 1;
      // this.TabName = 1;
      this.filters.Year = year;
      await this.GetRequestTasksData();
      //this.GetDataForReport();
    },
    async onMonthChange(month) {
      // this.TabName = 1;
      this.filters.Month = month;

      await this.GetRequestTasksData();
      //this.GetDataForReport();
    },
    async openingTimeAsigment() {
      this.whatsFor = "Asigning_Time";
      this.actualResquest = this.TasksData.filter(
        (td) => td.IsItClosed === false
      );

      this.filtersForData = this.filters;
      this.filtersForData.TabName = this.TabName;
      this.isTimeAssigmentVisible = true;

      //await this.GetRequestTasksData();
    },
    async OntimeAssigmentCloses() {
      //this.whatsFor = "multiple_editions";
      this.isTimeAssigmentVisible = false;
      await this.ReorderTasksMethod();
      await this.GetRequestTasksData();
      //this.GetDataForReport();
    },
    async handlePushAction(option) {
      const { row } = option;

      switch (option.command) {
        case "view_task":
          this.DetailsDialogData = {
            requestsId: row.OriginalID,
            comments: [],
            descripcionLaga: row.Descripcion,
            descripcionCorta: row.Name,
            commentReasonToReopen: "",
            Reopen: "",
            evidences: row.Evidence || []
          };
          this.isDetailsVisible = true;
          break;
        case "edit_task_time":
          this.whatsFor = option.command;
          row.TypeOfTime = "h"; // Default to "h"
          this.actualResquest = [row];
          this.isTimeAssigmentVisible = true;
          break;
        case "close_task":
          if (row.TimeOntask === 0) {
            this.$alert(
              "Antes de poder cerrar esta tarea debe asignarle tiempo a la misma",
              "Tarea sin tiempo asignado!",
              {
                confirmButtonText: "De acuerdo",
                type: "warning",
                callback: async (action) => {
                  this.$message({
                    type: "info",
                    message: `action: ${action}`
                  });
                  await this.openingTimeAsigment();
                }
              }
            );
          } else {
            this.RequestTaskId = option.row.ID;
            this.RequestTaskOriginalId = option.row.OriginalID;
            if (option.row.ID.startsWith("SE-")) {
              this.isCloseServiceRequestDialogVisible = true;
            } else {
              this.isEvidenceDialogVisible = true;
            }
          }
          break;
        case "reopen-task":
          await this.ReopenTask(row);
          break;
        case "edit_task_due_date":
          this.ActualTaskInfo = row;
          this.IsDueDateDialogVisible = true;
          break;
        case "edit_responsible":
          this.ActualTaskInfo = row;
          this.isResponsibleDialogVisible = true;
          break;
        case "reassign_close_date":
          this.ActualTaskInfo = row;
          this.IsCloseDateDialogVisible = true;
          break;
        case "order_tasks":
          this.RecalculateTaskData();
          break;
        case "delete_task":
          await this.$confirm(
            "¿Estás seguro de que deseas eliminar esta tarea?",
            "Confirmación",
            {
              confirmButtonText: "Sí",
              cancelButtonText: "No",
              type: "warning"
            }
          )
            .then(async () => {
              await this.$http
                .put("/api/ReporteGestion/DleteTask", {
                  Id: option.row.OriginalID,
                  Task: option.row.ID,
                  IsEneabled: false
                })
                .then(async () => {
                  this.TasksData = [];
                  await this.GetRequestTasksData();
                });
            })
            .catch(async () => {
              // Acción cancelada
              this.TasksData = [];
              await this.GetRequestTasksData();
            });
          break;
        default:
          break;
      }
    },
    onEvidenceClose(val) {
      this.isEvidenceDialogVisible = val;
    },
    onUpdateReport() {
      this.GetRequestTasksData();
    },
    OnDirectionSelected(val) {
      this.filters.Direction = val;

      //this.GetDataForReport();
    },
    OnDeparmentSelected(val) {
      this.filters.Deparment = val;
    },
    async OnResponsibleSelected(val) {
      this.filters.Responsible = val;
      // this.TabName = 1;
      await this.KnowIfIsHisSupervisor(val);
      await this.ReorderTasksMethod();
      await this.GetRequestTasksData();
      //this.GetDataForReport();
    },
    async handleTabClick(tab) {
      // Actualizamos TabName con el nombre del tab y realizamos la carga adecuada
      this.TabName = Number(tab.name);
      await this.GetRequestTasksData();
    },
    OnClosingServiceRequesCloseDialog(val) {
      this.isCloseServiceRequestDialogVisible = val;
    },
    async UpdateTimeAsigmentData() {
      this.TasksData = [];
      this.isTimeAssigmentVisible = false;
      await this.GetRequestTasksData();
    },
    async KnowIfIsHisSupervisor(responsible) {
      this.AmIsupervisor = false;
      await this.$http
        .get("/api/ReporteGestion/IsHisSupervisor", {
          params: {
            responsibleID: responsible,
            currentUserEmpId: this.currentUser.EmployeeId
          }
        })
        .then((response) => {
          this.AmIsupervisor = response.data;
        });
    },
    getSummaries(param) {
      const columnsToSum = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "Tiempo Total";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));

        if (
          !values.every((value) => isNaN(value)) &&
          columnsToSum.includes(column.property)
        ) {
          sums[index] =
            values
              .reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
              .toFixed(2) + " horas";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    // async OnEmployeedSelected(employSelected) {
    //   this.filters.Responsible = employSelected;
    //   await this.GetRequestTasksData();
    // },
    getWeekOfMonth(date = new Date(), startOfWeek = 0) {
      // Clone the date to avoid mutating the original
      const currentDate = new Date(date);
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth();

      // First day of the month
      const firstDay = new Date(year, month, 1);
      const firstDayOfWeek = firstDay.getDay();

      // Normalize startOfWeek: Sunday = 0, Monday = 1, ..., Saturday = 6
      const offset = (7 + firstDayOfWeek - startOfWeek) % 7;

      // Calculate the adjusted day index
      const adjustedDate = currentDate.getDate() + offset;

      // Compute week number (1-based)
      return Math.ceil(adjustedDate / 7);
    },
    OnClosingDetailsDialog() {
      this.isDetailsVisible = false;
    },
    OnResponsibleDialogClose() {
      this.isResponsibleDialogVisible = false;
    },
    async OnResponsibleUpdated() {
      this.TasksData = [];
      await this.GetRequestTasksData();
      this.isResponsibleDialogVisible = false;
    },
    OnClosingDueDateDialog() {
      this.IsDueDateDialogVisible = false;
    },
    async OnNewDueDateUpdated() {
      this.IsDueDateDialogVisible = false;
      this.TasksData = [];
      await this.GetRequestTasksData();
    },
    OnClosingCloseDateDialog(val) {
      this.IsCloseDateDialogVisible = val;
    },
    async OnNewCloseDateUpdated() {
      this.IsCloseDateDialogVisible = false;
      this.TasksData = [];
      await this.GetRequestTasksData();
    },
    getWeeksInMonth(year, month) {
      // Día inicial del mes
      // Primer día del mes
      const firstDay = new Date(year, month - 1, 1);
      // Último día del mes
      const lastDay = new Date(year, month, 0);

      // Obtener el domingo anterior o igual al primer día del mes
      const firstSunday = new Date(firstDay);
      firstSunday.setDate(firstDay.getDate() - firstDay.getDay());

      // Obtener el sábado siguiente o igual al último día del mes
      const lastSaturday = new Date(lastDay);
      lastSaturday.setDate(lastDay.getDate() + (6 - lastDay.getDay()));

      // Calcular la diferencia en días
      const diffInDays =
        Math.floor((lastSaturday - firstSunday) / (1000 * 60 * 60 * 24)) + 1;

      // Número total de semanas
      return diffInDays / 7;
    },
    OnStatusSelected(status) {
      this.filters.Status = status;
    }
  }
};
</script>

<style lang="scss" scoped>
.rowMargin {
  margin-bottom: 30px;
}

.colMargin {
  margin-left: 10px;
}

.red {
  color: red;
}
.yellow {
  color: orange;
}
.green {
  color: green;
}

.justifiyingContent {
  display: flex;
  justify-content: center;
}
.AligningContent {
  display: flex;
  align-items: center;
}
.ResponsibleName {
  margin: 0%;
}

.marginBottom {
  margin-bottom: 1em;
}

.MyParagraph {
  margin: 0;
  padding: 0;
  font-size: 12px;
}

.JustifyEnd {
  display: flex;
  justify-content: flex-end;
}

.custom-tab {
  color: green;
  background-color: lightgreen;
  padding: 8px 13px 8px 13px;
  border-radius: 4px;
}

::v-deep .el-tabs__item.is-active .custom-tab {
  font-weight: bold;
  background-color: lightgreen;
}
</style>
